import { render, staticRenderFns } from "./children.vue?vue&type=template&id=5bb1acdd&scoped=true&"
import script from "./children.vue?vue&type=script&lang=js&"
export * from "./children.vue?vue&type=script&lang=js&"
import style0 from "./children.vue?vue&type=style&index=0&id=5bb1acdd&lang=scss&scoped=true&"
import style1 from "./children.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb1acdd",
  null
  
)

export default component.exports